
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import TasksStatusListView from "./tasks_status-list.html";
import TasksStatusEditView from "./tasks_status-edit.html";

angular.module("tasks_status", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('tasks_status', {
                url: "/tasks_status",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('tasks_status.list', {
                url: "/list",
                controller: "TasksStatusListCtrl",
                template: TasksStatusListView,
                requiredPermission: ["TASKS_STATUS_READ"]
            })             
            .state('tasks_status.edit', {
                url: "/edit/:id",
                controller: "TasksStatusEditCtrl",
                template: TasksStatusEditView,
                requiredPermission: ["TASKS_STATUS_READ"]
            })
    }])
;